import { Select, Spin } from 'antd'
import debounce from 'lodash/debounce'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import React, { useState } from 'react'

const { Option } = Select

let latestFetch = 0

const RemoteFilter = props => {
  const {
    remoteSearch: { apiFn, paramSearchQuery, styleSelect, ...rest },
    tableDropdownFn: { setSelectedKeys, confirm },
  } = props

  const [data, setData] = useState([])

  const [fetching, setFetching] = useState(false)

  const fetchData = async value => {
    if (!value) {
      return
    }

    setData([])
    setFetching(true)

    const params = {}
    params[paramSearchQuery] = value

    // Update state 'data' with latest triggered fetch
    latestFetch += 1
    const fetchID = latestFetch

    const data = await apiFn(params)

    if (fetchID === latestFetch) {
      setData(data)
      setFetching(false)
    }
  }

  const fetchDataWrapper = debounce(fetchData, 800)

  const handleChange = value => {
    /*
      When truthy value:
      - mode single => single value
      - mode multiple => array

      On clear field:
      - mode = single => value = undefined
      - mode = single => value = []
    */
    let toSend = [] // setSelectedKeys defaults to [] -> see ANTD docs

    if (value) {
      if (!isArray(value)) {
        toSend = [value]
      } else {
        toSend = value
      }
    }

    setSelectedKeys(toSend)
    confirm()

    setData(toSend)
    setData([])
    setFetching(false)
  }

  return (
    <Select
      {...rest}
      // DO NOT modify below default props
      style={styleSelect ? { ...styleSelect } : { width: '100%', marginBottom: 8, marginTop: 8 }}
      showSearch
      onSearch={fetchDataWrapper}
      onChange={handleChange}
      onFocus={() => fetchDataWrapper(' ')}
      notFoundContent={fetching ? <Spin size="small" /> : null}
    >
      {data.map(d => {
        const isString = !isObject(d)

        return (
          <Option key={isString ? d : d.value} value={isString ? d : d.value} title={isString ? d : d.text}>
            {isString ? d : d.text}
          </Option>
        )
      })}
    </Select>
  )
}

export default RemoteFilter
